export const type = 'ADDRESS_ACK_API_ERROR';

export default () => ({
  type,
  payload: {},
  error: false,
});
